import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

export const getHomeTestimonials = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/testimonials/admin/get-all`);
        return response.data;
    } catch (error) {
        console.error("Error fetching testimonials:", error);
        throw error;
    }
};

export const createTestimonial = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/testimonials`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating testimonial:", error);
        throw error;
    }
};

export const updateTestimonial = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/testimonials/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating testimonial:", error);
        throw error;
    }
};

export const deleteTestimonial = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/testimonials/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting testimonial:", error);
        throw error;
    }
};
